import moment from 'moment';
import React from 'react';
import Message from './message';

const MessageList = React.memo(({ messages, isSkipTimeBanner }) => {

    const msgDates = new Set();

    const formatMsgDate = (created_date) => {

        const today = moment().startOf('day');
        const msgDate = moment(created_date);
        let dateDay = '';

        if(msgDate.isSame(today, 'day')){
            dateDay = 'Today';
        }
        else if (msgDate.isSame(today.clone().subtract(1, 'days'), 'day')){
            dateDay = 'Yesterday';
        }
        else{
            dateDay = msgDate.format('MMMM D, YYYY');
        }

        return dateDay
    }

    const renderMsgDate = (message, nextMessage) => {

        if(!message?.created){
            return null;
        }

        const dateTimeStamp = moment(message.created, 'YYYY-MM-DD').valueOf();
        let nextMsgdateTimeStamp = '';
        if(nextMessage){
            nextMsgdateTimeStamp = moment(nextMessage.created, 'YYYY-MM-DD').valueOf();
        }
        
        if(msgDates.has(dateTimeStamp) || (nextMsgdateTimeStamp && nextMsgdateTimeStamp == dateTimeStamp)){
            return null
        }
        else{
            msgDates.add(dateTimeStamp);
            return (
                <div className='py-2 flex justify-center items-center'>
                    <span id="msg_day" className='px-2 py-1 shadow font-medium rounded-lg text-gray-400 bg-white border-gray-300'>
                        {formatMsgDate(message.created)}
                    </span>
                </div>
            )
        }
    }

    return (
        <>
            {messages?.map((message, index) => (
                <>
                    <Message msg={message} />
                    {isSkipTimeBanner ? null : renderMsgDate(message, messages[index+1])}
                </>
            ))}
        </>
    );
});

export default MessageList;